module.exports = __webpack_public_path__ + "img/m-partners-banner.ade3b7ba.webp";